"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const SegmentContext = react_1.createContext({
    onTabChange: () => { },
    tab: '',
});
SegmentContext.displayName = 'SegmentContext';
exports.default = SegmentContext;
